import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BreadcrumbsComponentDef } from '@df/ui/common/breadcrumbs.component.def';
import { HrefComponent } from '@df/ui/common/href/href.component';
/**
 * Breadcrumbs component
 *
 * ## usage
 *
 * <breadcrumbs></breadcrumbs>
 */
@Component({
    selector: 'breadcrumbs',
    templateUrl: './breadcrumbs.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, HrefComponent]
})
export class BreadcrumbsComponent extends BreadcrumbsComponentDef {
}
